export type BcContestBlock = 'B' | 'C';

export type BcContestStatus = 'Draft' | 'Published' | 'Completed' | 'Cancelled';

export type BcContestProbability = 'Low' | 'Medium' | 'High';

export type BcContestResult = 'In' | 'Out' | 'NotApplicable';

export const permissions = {
    view: 'BC_CONTEST.VIEW',
    edit: 'BC_CONTEST.EDIT',
    apply: 'BC_CONTEST.APPLY',
    bypass: 'BC_CONTEST.BYPASS',
    setStudent: 'BC_CONTEST.SET_STUDENT'
};

export interface IBcContest {
    Id: number;
    Name: string;
    Block: BcContestBlock;
    PeriodId: string;
    Status: BcContestStatus;
    CourseLimit: number;
    OpenedFrom: Date | string;
    OpenedTo: Date | string;
    ResultsVisibleFrom: Date | string;
    ResultsVisibleTo: Date | string;
    Description: string;
    DescriptionEN: string;
    Submitted?: Date | string;
    HasSubmitError: boolean;
    IsActive: boolean;
    IsOpened: boolean;
}

export interface IBcAvailableContest {
    Name: string;
    PeriodId: string;
    Block: BcContestBlock;
}

export interface IBcActiveContest {
    Id: number;
    Name: string;
    Block: BcContestBlock;
    PeriodId: string;
    CourseLimit: number;
    IsOpened: boolean;
}

export interface IBcContestCourse {
    Id: number;
    Code: string;
    Name: string;
    GroupName: string;
    PlanningPeriod: string;
    StudyProgram: string;
    ApplicationCount: number;
    InApplicationCount: number;
}

export interface IBcContestStudent {
    Id: number;
    FullName: string;
    Upn: string;
    Program: string;
    CreditPoints: number;
    ApplicationCount: number;
    Grade: number;
    CustomGrade?: number;
}

export interface IBcContestProgram {
    Code: string;
    Total: number;
    Submitted: number;
    Pending: number;
}

export interface IBcContestEditModel {
    PeriodId: string;
    Block: BcContestBlock;
    CourseLimit: number;
    Status: BcContestStatus;
    OpenedFrom: Date | string;
    OpenedTo: Date | string;
    ResultsVisibleFrom: Date | string;
    ResultsVisibleTo: Date | string;
    Description: string;
    DescriptionEN: string;
}

export interface IBcContestStudentData {
    Id: number;
    StudentId: string;
    FullName: string;
    Upn: string;
    CertNumber: string;
    Program: string;
    CreditPoints: number;
    HasApplied: boolean;
}

export class IBcContestStudentCourse {
    SubjectSemesterId: string;
    Number: number;
    ApplicationId?: number;
    ApplicationCount: number;
    Subject: string;
    SubjectCode: string;
    SemesterNumber: number;
    Department: string;
    Manager: string;
    ExaminationType: string;
    Language: string;
    Block: string;
    CreditPoints: number;
    Ects: number;
    Group: string;
    GroupId: string;
    GroupDay: string;
    GroupMaxSize: number;
    TimeFrom: string;
    TimeTo: string;
    Location: string;
    LocationId: string;
    Url: string;
    HasDetailedPlanning: boolean;
    Info: string;
    Probability?: BcContestProbability;
    Priority?: number;
    Result?: BcContestResult;
}

export interface IBcContestEvent {
    Number: number;
    Address: string;
    AddressId: string;
    DateTime: string;
    Date: Date | string;
    TimeFrom: string;
    TimeTo: string;
}

export interface IBcContestApplication {
    Id: number;
    StudentId: number;
    CourseId: number;
    StudentUpn: string;
    StudentName: string;
    Program: string;
    SubjectCode: string;
    SubjectName: string;
    GroupMaxSize: number;
    Priority: number;
    Grade: number;
    AlgorithmResult?: BcContestResult;
    Result?: BcContestResult;
    Place?: number;
    Submitted?: Date | string;
    SubmitError?: string;
}

export interface IBcContestFilters {
    Programs: string[];
    CreditPoints: number[];
}
